export function floatingNav() {
  const floatingNav = document.querySelector('.empower-block__floating-nav');

  if (window.innerWidth > 1070) {
    if (floatingNav) {
      const scrollOffset = 400;
      const offset = 25;

      window.addEventListener('scroll', function () {
        if (window.scrollY > scrollOffset) {
          floatingNav.classList.add('is-sticky');
          floatingNav.style.top = `${offset}px`;
        } else {
          floatingNav.classList.remove('is-sticky');
          floatingNav.style.top = '';
        }
      });
    }
  }
}
